import z from "zod";


export const ReportNovosNegociosColumnsSchema = z.object({
    nroNegocio: z.boolean().default(false),
    data: z.boolean().default(false),
    cliente: z.boolean().default(false),
    cidade: z.boolean().default(false),
    telefone: z.boolean().default(false),
    nroEdital: z.boolean().default(false),
    centroCusto: z.boolean().default(false),
    informacoes: z.boolean().default(false),

});


export const ReportNovosNegociosSchema = z.object({
    requiredMimeType: z.string().optional().nullable(),
    centroCusto: z.array(z.number()).nullable().default(null),
    titulo: z.string().optional().nullable(),
    status: z.array(z.number()).nullable().default(null),
    dataDe: z.coerce.date().optional().nullable(),
    dataAte: z.coerce.date().optional().nullable(),

    colunas: ReportNovosNegociosColumnsSchema,

});

/**
 * ReportNovosNegociosForm
 */

export type ReportNovosNegociosForm = z.infer<typeof ReportNovosNegociosSchema>;

export type ReportNovosNegociosColumnsForm = z.infer<typeof ReportNovosNegociosColumnsSchema>;

export const defaultReportNovosNegociosForm: ReportNovosNegociosForm = {
    centroCusto: null,
    titulo: null,
    status: null,
    dataDe: null,
    dataAte: null,
    requiredMimeType: null,

    colunas: {
        nroNegocio: true,
        data: true,
        cliente: true,
        cidade: true,
        telefone: true,
        nroEdital: true,
        centroCusto: true,
        informacoes: true,

    }
};